import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { addIndex, map } from "ramda";
import classNames from "classnames";

import * as styles from "./styles.module.scss";
import { IMenuItem } from "../sidebar/index";
import lockedIcon from "../../images/icons/adengage/locked.svg";
import unlockedIcon from "../../images/icons/adengage/unlocked.svg";
import arrowLeft from "../../images/icons/adengage/arrow-left.svg";
import edoLogoHorizontal from "../../images/icons/adengage/edo-logo-horizontal-grey.svg";
import Tippy from "@tippyjs/react";
import AdEngageButton from "components/ad_engage_button";


import { adEngagePath } from "utils/constants";
import { BrandMetadata } from "models/brand";


export interface BrandSideBarMenuProps {
  selectedItem?: string;
  menuItems: Array<IMenuItem>;
  fromTopBrands?: boolean;
  brandMetadata?: BrandMetadata;
  didSelectItem?: (item: IMenuItem) => void
}

const BrandSideBarMenu: React.FC<BrandSideBarMenuProps> = ({
  menuItems,
  fromTopBrands,
  brandMetadata,
  selectedItem,
  didSelectItem = () => { }
}) => {

  const [pathName, setPathName] = useState("");
  useEffect(() => {
    if (typeof window != "undefined") {
      setPathName(location?.pathname);
    }
  }, []);

  const backButtonPath = fromTopBrands ? adEngagePath : pathName.split("/").slice(0, -2).join("/");
  const renderMenuItem = (
    item: IMenuItem,
    selectedItem?: string,
  ): React.ReactElement => {
    const { label, divider, bold, locked, onClick, path } = item;

    if (divider) {
      return <hr key={label} />
    }

    if (path) {
      return (
        <Link to={path}>
          <li
            key={label}
            className={
              classNames({
                [styles.bold]: bold,
                [styles.active]: selectedItem === label,
                [styles.locked]: locked
              })
            }
            onClick={onClick ?? (() => didSelectItem(item))}
          >
            <div className="margin-left-16 flex-row">
              <div className={styles.lockLogoContainer}>
                {locked
                  ? <img src={lockedIcon} alt="locked: " />
                  : <img src={unlockedIcon} alt="unlocked: " />
                }
              </div>
              <div className={styles.menuItemLabel}>{label}</div>
            </div>
          </li>
        </Link>
      )
    }

    return (
      <li
        key={label}
        className={
          classNames({
            [styles.bold]: bold,
            [styles.active]: selectedItem === label,
            [styles.locked]: locked
          })
        }
        onClick={onClick ?? (() => didSelectItem(item))}
      >
        <div className="margin-left-16 flex-row">
          <div className={styles.lockLogoContainer}>
            {locked
              ? <img src={lockedIcon} alt="locked: " />
              : <img src={unlockedIcon} alt="unlocked: " />
            }
          </div>
          <div className={styles.menuItemLabel}>{label}</div>
        </div>
      </li>
    );
  }

  const sideBarModal = (<div className={styles.sideBarModal}>
    <div className={styles.sideBarModalHeader}>
      Unlock A New Level of Marketing Precision
    </div>
    <div className={styles.sideBarModalContent}>
      Get a deeper view into a brand by products, networks, programs and more
    </div>
    <AdEngageButton label="Request Demo" gotoLink="/contact-us" href={"/contact-us"} />
  </div>);

  return (
    <aside className={styles.menu}>
      <Link to={backButtonPath}>
        <div className={classNames("flex-row", styles.backButton)}>
          <div className={styles.backButtonLogoContainer}>
            <img src={arrowLeft} alt="" />
          </div>
          <div className={styles.backButtonLabel}>
            {fromTopBrands ? "Back to Top Brands" : "Back to Category"}
          </div>
        </div>
      </Link>
      <div className={styles.brandMetadataContainer}>
        <div className={styles.brandLogoContainer}>
          <img className={classNames({ [styles.brandLogoPlaceholder]: !brandMetadata?.image_url })} src={brandMetadata?.image_url ? brandMetadata?.image_url : edoLogoHorizontal} alt={brandMetadata?.brand_name} />
        </div>
        <div className={styles.brandName}>
          {brandMetadata?.brand_name}
        </div>
        <div className={styles.categoryName}>
          {brandMetadata?.category_name}
        </div>
      </div>
      <ul className={classNames(styles.menuList)}>
        {
          addIndex(map)(
            (item: IMenuItem, i: number) => renderMenuItem(item, selectedItem),
            menuItems.filter((menuItem) => !menuItem.locked)
          )
        }
      </ul>
      <Tippy
        arrow={false}
        content={sideBarModal}
        interactive={true}
        placement={"right"}
        max-width={300}
      >
        <ul className={classNames(styles.menuList)}>
          {
            addIndex(map)((item: IMenuItem, i: number) => renderMenuItem(item, selectedItem), menuItems?.filter((menuItem) => menuItem?.locked))
          }
        </ul>
      </Tippy>
    </aside>
  )
};

export default BrandSideBarMenu;

